<template>
  <div class="entreprise">
      <div class="d-flex bloc-entreprise">
        <img v-if="entreprise.x_studio_url_image_sur_wordpress" class="logo-entreprise" :src="entreprise.x_studio_url_image_sur_wordpress" alt="">
        <img v-if="!entreprise.x_studio_url_image_sur_wordpress" class="logo-entreprise" :src="defaultImg" alt="">
        <div class="padding">
          <div class="d-flex">
            <p class="margin-p"><strong>{{ entreprise.x_studio_field_k9Nz7 }}</strong></p>
            <a v-if="entreprise.x_studio_wordpress_id" target="_blank" :href="`https://digital113.fr/?p=${entreprise.x_studio_wordpress_id}`" class="margin-p link">Plus d'informations</a>
          </div>
          <p v-if="entreprise.x_studio_description_courte">
            {{ entreprise.x_studio_description_courte }}
          </p>
          <a
              v-if="entreprise.street && entreprise.zip && entreprise.city"
              target="_blank"
              class="link-company"
              :href="addressLink">
            <img :src="marker" alt="">
            {{ entreprise.street }} {{ entreprise.zip }} {{ entreprise.city }}
          </a>
        </div>
      </div>
    </div>
</template>

<script>

import marker from '../assets/marker2.png'
import defaultImg from '../assets/default-img.png'

export default {
  name: 'Entreprise',
  props: ['entreprise'],
  data: function () {
    return {
        marker: marker,
        addressLink: `https://www.google.com/maps/place/ ${this.entreprise.street} ${this.entreprise.zip} ${this.entreprise.city}`,
        defaultImg: defaultImg
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.d-flex {
  display: flex;
  flex-wrap: wrap;
}

.bloc-entreprise {
  background-color: white;
  padding: 10px 5px;
  align-items: center;
}

.margin-p {
  margin: 5px 10px;
}

p {
  text-align: left;
}

.padding {
  padding: 0 20px;
  width: calc(100% - 160px);
    box-sizing: border-box;
}

.entreprise {
  margin: 10px 0;
}

.logo-entreprise {
  height: 80px;
  width: 120px;
  object-fit: contain;
}

.link {
    color: #12204c;
}

.link-company {
  background-color: #374ebd;
  display: flex;
  width: max-content;
  font-size: 13px;
  padding: 6px 22px;
  align-items: center;
  color: white;
  cursor: pointer;
  border-radius: 3px;
}

.link-company:hover {
  background-color: #4f62c4;
}

.link-company img {
  height: 22px;
  margin-right: 18px;
}

@media (max-width: 800px) {
  .bloc-entreprise {
    flex-direction: column;
  }

  .bloc-entreprise .padding {
    width: 100%;
  }

  .link-company {
    max-width: 100%;
    box-sizing: border-box;
  }
}
</style>
